var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card shadow border-0"},[_c('div',{staticClass:"card-body py-5 text-center"},[_vm._t("prepend"),_c('div',{staticClass:"message-icon mb-2",class:_vm.iconClass}),_vm._t("default",function(){return [_c('div',{staticClass:"lead"},[_vm._v(_vm._s(_vm.message))])]}),_vm._t("append")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }